import React, { useEffect, useState } from "react";
import { cls } from "cls";
import ReactDOMServer from "react-dom/server";
import addToCartRequest, { AddToCartProduct } from "~/ProductDetails/Pricing/AddToCart/request";
import Notification from "~/common/Notification";
import SuccessMessage from "~/productListing/ProductBox/SuccessMessage";
import { AddToCartModalNames } from "~/common/AddToCartModal";
import useAddToCartModals from "~/common/AddToCartModal/useAddToCartModals";
import { User } from "~/common/Store/models/User";
import CommercialUseOnlyModal from "~/common/AddToCartModal/CommercialUseOnlyModal";
export interface SamplingAddToCartProduct {
  description: string;
  feedIdentifier: string;
  imagePath?: string;
  itemNumber: string;
  itemNumberId: number;
  link: string;
  isInStock: boolean;
  price: number;
  plusPrice: number;
  minimumBuy: number;
  mustBuy: number;
  startBuy: number;
  isWebstaurantPlusEligible: boolean;
}
interface Props {
  isConsumable: boolean;
  product: SamplingAddToCartProduct;
  user: User;
}
interface AddToCartArgs {
  hasAcknowledgedCommercialUseWarning: boolean;
  hasCommercialAddress: boolean;
  openModals?: (modals: AddToCartModalNames[]) => void;
}
const SamplingAddToCart = ({
  product,
  isConsumable,
  user
}: Props) => {
  const [errorMessage, setErrorMessage] = useState("");
  const [hasAcknowledgedCommercialUseWarning, setHasAcknowledgedCommercialUseWarning] = useState(false);
  const hasCommercialAddress = user.registered && user.isCommercial;
  useEffect(() => {
    if (errorMessage) Notification.closeAll();
  }, [errorMessage]);
  const AddToCart = async ({
    openModals,
    hasAcknowledgedCommercialUseWarning,
    hasCommercialAddress
  }: AddToCartArgs) => {
    const addToCartProduct: AddToCartProduct = {
      ...product
    };
    if (openModals) {
      const modalsToOpen: AddToCartModalNames[] = [];
      if (isConsumable && !hasCommercialAddress && !hasAcknowledgedCommercialUseWarning) {
        modalsToOpen.push("commercialUse");
      }
      if (modalsToOpen.length > 0) {
        openModals(modalsToOpen);
        return;
      }
    }
    await addToCartRequest({
      product: {
        ...addToCartProduct
      },
      quantity: 1,
      isSample: true,
      gtmAtcProps: {
        source: "product detail"
      }
    }).then(successResponse => {
      if (successResponse) {
        new Notification({
          imageUrl: product.imagePath || "/images/products/new/imagecomingsoon_tn.jpg",
          heading: ReactDOMServer.renderToString(<SuccessMessage quantity={1} />),
          href: "/viewcart.cfm",
          body: product.description,
          buttonText: "View Cart",
          secondButtonText: "Checkout",
          secondHref: "/viewinfo.cfm"
        });
      } else {
        setErrorMessage("Error adding this item to your cart.");
      }
    });
  };
  const {
    openModals,
    activeModal,
    closeModal,
    submitModal
  } = useAddToCartModals({
    onComplete: (results, openModals) => {
      setHasAcknowledgedCommercialUseWarning(!!results.commercialUse);
      AddToCart({
        openModals,
        hasAcknowledgedCommercialUseWarning: !!results.commercialUse,
        hasCommercialAddress: !!hasCommercialAddress
      });
    }
  });
  const handleAddToCart = async (event: React.SyntheticEvent) => {
    event.preventDefault();
    return AddToCart({
      openModals,
      hasAcknowledgedCommercialUseWarning,
      hasCommercialAddress: !!hasCommercialAddress
    });
  };
  const isCommercialUseModalOpen = activeModal === "commercialUse";
  const ProductModals = () => <>
      {!hasCommercialAddress && isCommercialUseModalOpen && <CommercialUseOnlyModal {...{
      isOpen: isCommercialUseModalOpen,
      itemNumber: product.itemNumber,
      onClose: () => closeModal(),
      onSubmit: result => submitModal({
        commercialUse: result
      }),
      closeModal,
      submitModal,
      type: "sampling"
    }} />}
    </>;
  return <>
      <ProductModals data-sentry-element="ProductModals" data-sentry-source-file="SamplingAddToCart.tsx" />
      <div>
        <form action="/viewcart.cfm" className="form product_form" id="pdpsampling" method="post">
          <div className="btn-container">
            <input type="submit" className={cls("btn", "btn-cart", "btn-small", "py-0.5", "px-2", "text-sm")} style={{
            textShadow: "0px 1px 0px rgba(0, 0, 0, 0.25)",
            border: "1px solid rgba(0, 0, 0, .10)"
          }} value="Add to Cart" onClick={handleAddToCart} name="addToCartButton" data-action="addToCart" data-testid="SampleATC" aria-describedby="Add-to-cart" />
            {errorMessage.length > 0 && <p className="form__error">{errorMessage}</p>}
          </div>
        </form>
      </div>
    </>;
};
export default SamplingAddToCart;